module.exports = __webpack_public_path__ + "static/media/trip.comLogo.dbab5591.png";